<template>
  <v-container class="d-flex flex-column" style="height:100%!important;">
    <div class="d-inline-block vert-align-top ma-4" width="100%">
      <v-btn rounded depressed @click="$emit('close')" class="text-none font-weight-medium">
        <v-icon class="mr-1">mdi-undo-variant</v-icon> {{  $t('global.cancel')  }}
      </v-btn>
      <span class="title ml-4 text-left text-uppercase" style="color:var(--v-primary-base);">Reprogrammation...</span>
    </div>
    <div class="pb-4" style="height:100%!important;overflow-y:auto!important;">
      <div class="preview-card ongoing">
        <div class="impage_bloc_large mx-auto" v-if="!isVideo">
          <v-img class="photo_large" v-if="media" :src="thumbnailPath" width="100%"></v-img>
          <div class="status">
            <v-btn loading text icon depressed color="white" style="position:absolute;left:10px;bottom:7px;color:white;height:24px;width:24px;"></v-btn>
            <div class="status_title"> En attente de vos modifications </div>
            <div style="position:absolute;right:0px;bottom:0px;height:30px;width:34px;background-color:#252735;border-radius:6px 0px 0px 0px;">
              <v-icon style="position:absolute;right:5px;bottom:3px;color:white;">mdi-image-size-select-actual</v-icon>
            </div>
          </div>
        </div>
        <div>
          <video v-if="media && isVideo" :src="videoPath" :height="videoHeight" width="100%" muted controls></video>
        </div>
        <div class="photo_name mx-6 mt-4">
          {{ media.titre }}
        </div>
      </div>
      <div class="mx-6">
        <h3 class="mb-2">
          Programmation
        </h3>
        <div class="d-flex flex-row">
          <div class="mb-4 d-flex flex-column" style="width:50%">
            <span class="caption text-left">Début de diffusion</span>
            <v-menu
              ref="startingDate"
              v-model="menuStartingDate"
              :close-on-content-click="false"
              :return-value.sync="startingDate"
              transition="scale-transition"
              min-width="290px"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startingDate"
                  :readonly="true"
                  :hide-details="true"
                  :single-line="true"
                  v-on="on"
                  class="custom-text-field"
                  color="new_media"
                  style="width:180px!important;"
                  prepend-inner-icon="mdi-calendar-check"
                  outlined
                  rounded
                  dense
                ></v-text-field>
              </template>
              <v-date-picker light color="new_media" style="background-color:white;" first-day-of-week="1" reactive v-model="startingDate" scrollable :locale="$store.state.user.language">
                <v-btn rounded text style="width:45%;" class="mb-2 ml-2" @click="menuStartingDate = false">Annuler</v-btn>
                <v-spacer></v-spacer>
                <v-btn rounded outlined style="width:45%;" class="custom-valid-btn new-media mb-2 mr-2" @click="$refs.startingDate.save(startingDate)">Valider</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="d-flex flex-column">
            <span class="caption text-left">Fin de diffusion</span>
            <v-menu
              ref="endingDate"
              v-model="menuEndingDate"
              :close-on-content-click="false"
              :return-value.sync="endingDate"
              transition="scale-transition"
              min-width="290px"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endingDate" 
                  placeholder="_ _ _ _-_ _-_ _"
                  :readonly="true"
                  :hide-details="true"
                  :single-line="true"
                  v-on="on"
                  class="custom-text-field"
                  color="new_media"
                  style="width:180px!important;"
                  prepend-inner-icon="mdi-calendar-remove"
                  outlined
                  rounded
                  dense
                  clearable
                  clear-icon="mdi-close-circle"
                ></v-text-field>
              </template>
              <v-date-picker light color="new_media" style="background-color:white;" first-day-of-week="1" reactive v-model="endingDate" scrollable :locale="$store.state.user.language">
                <v-spacer></v-spacer>
                <v-btn rounded text style="width:45%;" class="mb-2 ml-2" @click="menuEndingDate = false">Annuler</v-btn>
                <v-btn rounded outlined style="width:45%;" class="custom-valid-btn new-media mb-2 mr-2" @click="$refs.endingDate.save(endingDate)">Valider</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>
      <div class="mx-6">
        <h3 class="mb-2">
          {{ $t('newMedia.broadcastDays') }}
        </h3>
        <div id="broadcastDays_container" class="d-flex flex-row justify-start" style="height:150px;width:100%;">
            <v-row no-gutters>
              <template v-for="day in broadcastDays">
                <v-col :key="day.id">
                  <div class="divObject custom-center pl-3" style="background-color:transparent;width:180px!important;margin-right:0!important;">
                    <v-switch inset dense hide-details class="form-checkbox" color="new_media" :label="day.name" v-model="chosenDays" :value="day">
                    </v-switch>
                  </div>
                </v-col>
              </template>
            </v-row>
        </div>
      </div>
      <div class="mx-6 mt-6">
        <h3 class="mb-2">
          Horaires de diffusion
        </h3>
        <div style="overflow:visible;">
          <div v-if="setBroadCastHours" class="pt-4 elevation-24-05" style="border-radius:18px;background-color:var(--v-contrast-base)!important;">
            <p class="px-4 text-center">Plage horaire activée<v-icon class="ml-2" color="new_media">mdi-check-circle</v-icon></p>
            <div class="d-flex flex-row justify-space-between px-4 mb-4">
              <div class="d-flex flex-column">
                <span class="caption mb-1">Commence à </span>
                <vue-time-picker class="custom-time-picker" color="new_media" v-model="startingHour">
                </vue-time-picker>
              </div>
              <div class="d-flex flex-column">
                <span class="caption mb-1">Se termine à </span>
                <vue-time-picker class="custom-time-picker" color="new_media" v-model="endingHour">
                </vue-time-picker>
              </div>
            </div>
            <v-btn
              depressed
              block
              dark
              color="var(--v-error-darken1)"
              style="border-radius:0 0 18px 18px;text-transform:none;"
              @click="removeHours">
              <v-icon class="mr-2">
                mdi-chevron-right
              </v-icon>
              Diffuser toute la journée
              <v-icon class="ml-2">
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </div>
          <div v-if="!setBroadCastHours" class="pt-4 elevation-24-05" style="border-radius:18px;background-color:var(--v-contrast-base)!important;">
            <p class="px-4 text-center">
              Diffusion toute la journée
              <v-icon class="ml-2" color="new_media">
                mdi-check-circle
              </v-icon>
            </p>
            <v-btn
              depressed
              block
              dark
              color="new_media"
              class="font-weight-medium"
              style="border-radius:0 0 18px 18px;text-transform:none;"
              @click="setBroadCastHours = true">
            <v-icon class="mr-2">
              mdi-chevron-right
            </v-icon>
              Activer une plage horaire
            <v-icon class="ml-2">
              mdi-chevron-left
            </v-icon>
            </v-btn>
          </div>
        </div>
        <div v-if="displayDuration > 0 && !isVideo">
          Durée d'affichage en sec :
          <v-text-field
            v-model="displayDuration"
            type="number"
            class="d-inline-block"
            style="width:60px;"
          ></v-text-field>
        </div>
      </div>
      <div class="mx-6 mt-6">
        <h3 class="mb-2">
          Écrans de diffusion
        </h3>
        <div class="font-weight-regular">Vous pouvez ci-dessous AJOUTER
          <v-icon class="mx-1" color="rgb(var(--new-media-rgb))">mdi-television-play</v-icon>
          ou RETIRER
          <v-icon class="mx-1">mdi-television-off</v-icon> un écran de diffusion :
        </div>
        <div>
          <template>
            <v-list id="screenslist" style="overflow-y:auto;max-height:400px;">
              <v-list-item v-for="screen in screens" :key="screen">
                <v-list-item-action >
                  <v-checkbox disabled off-icon="mdi-television-off" on-icon="mdi-television-play" color="rgb(var(--new-media-rgb))" :label="screen" v-model="selectedScreens" :value="screen"></v-checkbox>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>
        </div>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="ma-6">
      <v-btn rounded :loading="loading" outlined large block class="custom-valid-btn new-media" :disabled="disableButton || ((!isStartingHourValid || !isEndingHourValid) && setBroadCastHours)" @click="updateSettings">
        Appliquer les modifications
      </v-btn>
    </div>
    <v-snackbar @click.native="snackbarEditFailed = false" v-model="snackbarEditFailed" :timeout="timeoutDuration">
      La modification a échouée
    </v-snackbar>
  </v-container>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import FtpService from '@/services/FTPService'
import DBService from '@/services/DBService'
export default {
  props: ['file', 'from', 'isOldFile'],
  data () {
    return {
      startingDate: null,
      endingDate: null,
      menuStartingDate: false,
      menuEndingDate: false,
      broadcastDays: [
        { id: 0, code: '', name: this.$i18n.t('global.days.0') },
        { id: 4, code: 'J', name: this.$i18n.t('global.days.4') },
        { id: 1, code: 'L', name: this.$i18n.t('global.days.1') },
        { id: 5, code: 'V', name: this.$i18n.t('global.days.5') },
        { id: 2, code: 'A', name: this.$i18n.t('global.days.2') },
        { id: 6, code: 'S', name: this.$i18n.t('global.days.6') },
        { id: 3, code: 'R', name: this.$i18n.t('global.days.3') },
        { id: 7, code: 'D', name: this.$i18n.t('global.days.7') }
      ],
      chosenDays: [],
      media: null,
      screen: null,
      displayDuration: 10,
      setBroadCastHours: false,
      thumbnailPath: '',
      screens: [],
      endingHourFormat: '',
      startingHourFormat: '',
      startingHour: {},
      endingHour: {},
      isStartingHourValid: false,
      isEndingHourValid: false,
      selectedScreens: [],
      nameExtension: '',
      selectedDaysIDCSV: '',
      disableButton: false,
      loading: false,
      snackbarEditFailed: false,
      timeoutDuration: 4000,
      isVideo: false,
      videoPath: '',
      videoHeight: 270
    }
  },
  async created () {
    var serverPath = 'https://sandisplay.allsan.fr/players/' + this.$store.state.selectedSite.SitNom + '/PUB/'
    this.media = this.file
    if (!this.isOldFile)  {
      this.isVideo = this.media.media_name.endsWith('.avi') || this.media.media_name.endsWith('.mp4')
    } else {
      this.isVideo = this.media.fileProps.id.endsWith('.avi') || this.media.fileProps.id.endsWith('.mp4')
    }
    
    if (!this.isOldFile && this.media.sites.includes(',')) {
      serverPath = 'https://sandisplay.allsan.fr/players/' + this.media.sites.split(',')[0] + '/PUB/'
    } 
    if (!this.isOldFile) {
      if (this.$store.state.user.id === 295 && this.$store.state.selectedSite.SitNom.includes('Tous')) {
        this.selectedScreens = this.media.ecrans.split(',')
        this.screens = this.media.ecrans.split(',')
      } else {
        this.selectedScreens = this.media.ecrans.split(',') 
        this.$store.state.selectedSite.screens.forEach( (element) => {
          this.screens.push(element.server_name)
        })
      }

      this.displayDuration = this.media.duree_diffusion
      this.startingDate = new Date()
      this.startingDate.setYear(parseInt(this.media.date_debut.substring(0,4),10))
      this.startingDate.setMonth(parseInt(this.media.date_debut.substring(5,7),10) - 1)
      this.startingDate.setDate(parseInt(this.media.date_debut.substring(8),10))
      this.startingDate = this.startingDate.toISOString().substr(0, 10)

      if (this.media.date_fin) {
        this.endingDate = new Date()
        this.endingDate.setYear(parseInt(this.media.date_fin.substring(0,4),10))
        this.endingDate.setMonth(parseInt(this.media.date_fin.substring(5,7),10) - 1)
        this.endingDate.setDate(parseInt(this.media.date_fin.substring(8),10))
        this.endingDate = this.endingDate.toISOString().substr(0, 10)
      }

      if (this.media.jours_diffusion.includes(',')) {
        var brDays = this.media.jours_diffusion.split(',')
        for (let i = 0; i < brDays.length; i++) {
          this.chosenDays = this.broadcastDays.filter(function (element) {
            return brDays.includes(element.id.toString())
          })
          this.chosenDays.push(parseInt(brDays,10))
        }
      } else {
        this.chosenDays = this.broadcastDays.filter((element) => {
          return this.media.jours_diffusion === element.id.toString()
        })
      }

      if (this.media.miniature){
        this.thumbnailPath = serverPath + this.selectedScreens[0] + '/' + this.media.miniature
      } else {
        this.thumbnailPath = serverPath + this.selectedScreens[0] + '/bloc_pub1/' + this.media.media_name
      }

      if (this.isVideo) {
        this.videoPath = serverPath + this.selectedScreens[0] + '/bloc_pub1/' + this.media.media_name + '.mp4'
      }
    } else {
      if (this.media.fileProps[0].name.includes('__jd')) {
        var _jd = this.media.fileProps[0].name.split('__jd')[1]
        var brDays = _jd.includes('_') ? _jd.substring(0, _jd.indexOf('_')) : _jd.substring(0, _jd.indexOf('.'))
        brDays = brDays.split('')
        for (let i = 0; i < brDays.length; i++) {
          this.broadcastDays.forEach(element => {
            if (brDays.includes(element.code)) {
              this.chosenDays.push(element)
            }
          })
        }
      } else {
        this.chosenDays.push({ id: 0, code: '', name: this.$i18n.t('global.days.0') })
      }

      this.$store.state.selectedSite.screens.forEach(element =>{
        this.screens.push(element.server_name)
      }, this)
      this.media.fileProps.forEach(element =>{
        this.selectedScreens.push(element.path.split('/')[3])
      }, this)

      if (this.media.fileProps[0].name.includes('__d')) {
        var _d = this.media.fileProps[0].name.split('__d')[1].substring(0, 8)
        this.startingDate = new Date()
        this.startingDate.setYear(parseInt(_d.substring(0,4),10))
        this.startingDate.setMonth(parseInt(_d.substring(4,6),10) - 1)
        this.startingDate.setDate(parseInt(_d.substring(6),10))
        this.startingDate = this.startingDate.toISOString().substr(0, 10)
      }
      if (this.media.fileProps[0].name.includes('__f')) {
        var _f = this.media.fileProps[0].name.split('__f')[1].substring(0, 8)
        this.endingDate = new Date()
        this.endingDate.setYear(parseInt(_f.substring(0,4),10))
        this.endingDate.setMonth(parseInt(_f.substring(4,6),10) - 1)
        this.endingDate.setDate(parseInt(_f.substring(6),10))
        this.endingDate = this.endingDate.toISOString().substr(0, 10)
      }
      if (this.media.fileProps[0].name.endsWith('.avi') || this.media.fileProps[0].name.endsWith('.mp4')) {
        this.displayDuration = 0
        var folders = this.media.fileProps[0].path.split('/')
        var videoThumbnail = this.media.fileProps[0].name.substring(9,22)
        var videoPath = this.media.fileProps[0].path.substring(0, this.media.fileProps[0].path.lastIndexOf('/'))
        this.thumbnailPath = serverPath + folders[3] + '/' + videoThumbnail + '.jpg'
        if (this.isVideo) {
          if (this.media.fileProps[0].name.endsWith('.mp4')) {
            this.videoPath = 'https://sandisplay.allsan.fr/players' + videoPath + '/' +  this.media.fileProps[0].name
          } else {
            this.videoPath = 'https://sandisplay.allsan.fr/players' + videoPath + '/' +  this.media.fileProps[0].name + '.mp4'
          }
        }
      } else {
        if (this.media.fileProps[0].name.includes('__tpf')) {
          var split = this.media.fileProps[0].name.split('__tpf')
          var tpf = split[1]
          if (tpf.includes('_')) {
            this.displayDuration = tpf.substring(0, tpf.indexOf('_'))
          } else {
            this.displayDuration = tpf.substring(0, tpf.indexOf('.'))
          }
        }
        this.thumbnailPath = 'https://sandisplay.allsan.fr/players' + this.media.fileProps[0].path
      }   
    }
  },
  components: {
    'vueTimePicker': VueTimepicker
  },
  methods: {
    closeModal () {
      document.location.reload(true)
    },
    removeHours () {
      this.setBroadCastHours = false
      this.endingHour.HH = ''
      this.endingHour.mm = ''
      this.startingHour.HH = ''
      this.startingHour.mm = ''
      this.isEndingHourValid = false
      this.isStartingHourValid = false
    },
    async updateSettings () {
      this.disableButton = true
      this.loading = true
      this.nameExtension = '__jd'
      this.selectedDaysIDCSV = ''
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0) {
          this.selectedDaysIDCSV = '0,'
          this.nameExtension = ''
          break
        } else {
          this.nameExtension += this.chosenDays[i].code
          this.selectedDaysIDCSV += this.chosenDays[i].id + ','
        }
      }
      this.selectedDaysIDCSV = this.selectedDaysIDCSV.substring(0, this.selectedDaysIDCSV.length - 1)
      if (this.setBroadCastHours) {
        if (this.startingHour) {
          let minutes = this.startingHour.mm === '' ? '00' : this.startingHour.mm
          let hours = this.startingHour.HH
          this.nameExtension += '__hd' + hours + minutes
          this.startingHourFormat = hours + minutes
        }
        if (this.endingHour) {
          let minutes = this.endingHour.mm === '' ? '00' : this.endingHour.mm
          let hours = this.endingHour.HH
          this.nameExtension += '__hf' + hours + minutes
          this.endingHourFormat = hours + minutes
        }
      }
      if (this.displayDuration && this.displayDuration != 10 && !this.isVideo) {
        if (this.displayDuration < 10) {
          this.nameExtension += '__tpf0' + this.displayDuration
        } else {
          this.nameExtension += '__tpf' + this.displayDuration
        }
        
      }
      if (this.startingDate) {
        let dateElements = this.startingDate.split('-')
        this.nameExtension += '__d' + dateElements[0] + dateElements[1] + dateElements[2]
      }
      if (this.endingDate) {
        let dateElements = this.endingDate.split('-')
        this.nameExtension += '__f' + dateElements[0] + dateElements[1] + dateElements[2]
      } 
      var newName = this.media.media_name.split('except__')[0] + 'except' + this.nameExtension
      if (this.isVideo) {
        newName = newName + '.avi'
      } else {
        newName = newName + '.jpg'
      }
      var response
      if (this.$store.state.user.id === 295) {
        response = await FtpService.renameFileCultura({
          ogName: this.media.media_name,
          screens: this.media.ecrans.split(','),
          newName: newName,
          sites: this.media.sites.split(',')
        })
      } else {
        response = await FtpService.renameFile({
          ogName: this.media.media_name,
          screens: this.media.ecrans.split(','),
          newName: newName,
          site: this.$store.state.selectedSite.SitNom,
          newScreens: this.selectedScreens
        })
      }
      if (response.status === 200) {
        var responseDB
        if (this.$store.state.user.id === 295) {
          responseDB = await DBService.updateMediaPropertiesCultura({
            id: this.media.id,
            newName: newName,
            selectedDays: this.selectedDaysIDCSV,
            dateDebut: this.startingDate,
            dateFin: this.endingDate,
            heureDebut: this.startingHourFormat,
            heureFin: this.endingHourFormat,
            tpf: this.displayDuration
          })
        } else {
          responseDB = await DBService.updateMediaProperties({
            id: this.media.id,
            newName: newName,
            selectedDays: this.selectedDaysIDCSV,
            screens: this.media.ecrans.split(','),
            newScreens: this.selectedScreens,
            dateDebut: this.startingDate,
            dateFin: this.endingDate,
            heureDebut: this.startingHourFormat,
            heureFin: this.endingHourFormat,
            tpf: this.displayDuration
          })
        }
        if (responseDB.status === 200) {
          this.$store.dispatch('setEditSuccessful', true)        
          this.closeModal()        
        } else {
          this.snackbarEditFailed = true
          this.disableButton = false
          this.loading = false
        }
      }
    } 
  },
  watch: {
    startingHour: function () {
      if (!this.setBroadCastHours) {
        this.isStartingHourValid = true
      } else if (!(this.startingHour.HH !== '' && this.startingHour.mm !== '')) {
        this.isStartingHourValid = false
      } else {
        this.isStartingHourValid = true
      }
    },
    endingHour: function () {
      if (!this.setBroadCastHours) {
        this.isEndingHourValid = true
      } else if (!(this.endingHour.HH !== '' && this.endingHour.mm !== '')) {
        this.isEndingHourValid = false
      } else {
        this.isEndingHourValid = true
      }
    },
    chosenDays: function () {
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0 && this.chosenDays.length > 1) {
          this.chosenDays.splice(i, 1)
          break
        }
      }
    }
  }
}
</script>

<style scoped>
.divObject{
  vertical-align: top;
  /* display: inline-block; */
  display: flex;
  margin-right: auto;
  background-color: rgba(9, 5, 33,0.1);
  height:36px;
  width:auto;
  border-radius:50em;
}

.form-checkbox {
  margin: auto;
  display: flex;
/*   display: block;*/
  padding-top:0px!important;
  margin-left:-2px!important;
}
</style>
